import { z } from "zod";

export const createOrUpdateCorrectiveVehicleRestitutionPayload = z.object({
  submittedBy: z.uuid(),
  driversHistory: z.uuid(),
  mileage: z.number(),
  isCabinCleaned: z.boolean(),
  isTrunkCleaned: z.boolean(),
  observations: z.string().nullable(),
  pictures: z.array(z.uuid()),
  picturesToUpload: z.array(
    z.object({
      originalFileName: z.string(),
      fileBuffer: z.string(),
    }),
  ),
});

export type CreateOrUpdateCorrectiveVehicleRestitutionPayload = z.infer<
  typeof createOrUpdateCorrectiveVehicleRestitutionPayload
>;
